<template>
  <section class="content_auto">
    <div class="warning-box">
      <img :src="require('@/assets/images/warning.png')" />
      <span>{{ $t('请手持证件正面·朗读以下范本并进行视频录製') }}</span>
    </div>
    <div class="sample-box">
      <div>{{ $t('范本') }}</div>
      <div>
        {{
          $t(
            '本人（XXX），证件号（证件号码），我的资金来源合法可靠，自愿交易比特币等数字资产，本人充分了解数字货币及潜在风险，本人具有抗风险的能力并愿意承担一切风险。另外，我确定此账号所有操作均为本人操作，该账号所产生的一切法律责任，由我个人承担。'
          )
        }}
      </div>
    </div>
    <div class="upload-box">
      <div class="upload-box-header">
        <span>{{ $t('手持证件') }}</span>
        <span>{{ $t('上传手持证件录制的视频') }}</span>
      </div>
      <CustomUpload v-model="fileUrl" name="video" />
    </div>

    <div class="tips-box">
      <div class="title">{{ $t('上传要求') }}</div>
      <div class="tip-item">1 {{ $t('必须能看清身份证信息') }}</div>
      <div class="tip-item">
        2
        {{
          $t('提交本申请代表承诺你的身份信息真实可靠，不存在盗用他人信息的情况')
        }}
      </div>
      <div class="tip-item">
        3
        {{
          $t(
            '大小不超过xxM，信息清晰、需手持有证件正面，朗读范本并进行视频录製',
            { size: 100 }
          )
        }}
      </div>
    </div>
    <div class="commit-btn-box">
      <el-button
        :loading="loading"
        :disabled="disabled"
        class="commit-btn"
        @click="commit"
      >
        {{ this.$t('提交') }}
      </el-button>
    </div>
  </section>
</template>
<script>
import { doCommitC3Auth } from '@/api/personal'
import { updateUserInfo } from '@/utils'

export default {
  name: 'KYC3Auth',
  data() {
    return {
      fileUrl: '',
      loading: false
    }
  },
  computed: {
    disabled() {
      return !this.fileUrl
    }
  },
  methods: {
    async commit() {
      if (this.disabled) {
        return
      }
      this.loading = true
      try {
        await doCommitC3Auth({ videoUrl: this.fileUrl })
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.$router.replace({ path: '/identity' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
section {
  .warning-box {
    width: 100%;
    height: 54px;
    background: #f9e0c7;
    border-radius: 3px 3px 3px 3px;
    display: flex;
    align-items: center;
    padding-left: 24px;
    img {
      height: 20px;
      width: 20px;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #1c1b1b;
    }
  }
  .sample-box {
    margin-top: 16px;
    // height: 124px;
    padding: 24px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #cccccc;
    font-size: 16px;
    font-weight: 500;
    color: #2f3342;
    line-height: 24px;
  }
  .upload-box {
    margin-top: 34px;
    .upload-box-header {
      margin-bottom: 19px;
      span {
        &:first-child {
          font-size: 16px;
          font-weight: 500;
          color: #000000;
        }
        &:last-child {
          font-size: 12px;
          font-weight: 500;
          color: #848e9c;
          margin-left: 8px;
        }
      }
    }
  }
  .tips-box {
    margin-top: 32px;
    .title {
      height: 24px;
      font-size: 16px;
      font-weight: 500;
      color: #c02e21;
      line-height: 24px;
      margin-bottom: 14px;
    }
    .tip-item {
      font-size: 16px;
      font-weight: 500;
      color: #848e9c;
      line-height: 24px;
      &:not(:first-child) {
        margin-top: 8px;
      }
    }
  }
  .commit-btn-box {
    margin: 64px 0 100px;
    text-align: center;
    .commit-btn {
      width: 580px;
      height: 60px;
      text-align: center;
      border-radius: 4px 4px 4px 4px;
      font-size: 18px;
      font-weight: 500;
      background: #1c1b1b;
      color: #ffffff;
      cursor: pointer;
      &.el-button.is-disabled,
      &.el-button.is-disabled:focus,
      &.el-button.is-disabled:hover {
        background: #a2a2a2;
        color: #fff;
        cursor: not-allowed;
      }
    }
  }
}
</style>
